import { render, staticRenderFns } from "./CLAPolicyInfo.vue?vue&type=template&id=365c08f8"
import script from "./CLAPolicyInfo.vue?vue&type=script&lang=js"
export * from "./CLAPolicyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports